import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export class Gallery {
    
    constructor(imgsSelector='.article-content img', galleryId='gallery-maker') {
      
      this.imgs = document.querySelectorAll(this.sanitize(imgsSelector));
      if(!this.imgs) return;
      
      this.galleryId = this.sanitize(galleryId);
      this.els;
      this.swiper;

      this.buildHtml();
      this.cloneImages();
      this.initSwiper();
      
    }

    sanitize(str) {
      return str.replace(/[^a-z0-9 #=\.\^\$\:\*\[\]\"]/gi,'-').toLowerCase();
    }

    buildHtml() {

      this.els = {
        modal: {el: 'div', id: this.galleryId, class: 'afg-modal'},
        swiper: {el: 'div', id: '', class: 'swiper'},
        swiperWrapper: {el: 'div', id: '', class: 'swiper-wrapper'},
        swiperNav: { el: 'div', id: '', class: 'swiper-arrows' },
        swiperPrev: { el: 'div', id: '', class: 'swiper-button-prev' },
        swiperNext: { el: 'div', id: '', class: 'swiper-button-next' },
        closeModal: { el: 'div', id: '', class: 'afg-close' }
      };

      for (let key in this.els) {
        let element = this.els[key];
        this.createElement(element.el, element.id, element.class);
      }
 
      this.els.swiperNav.appendChild(this.els.swiperPrev);
      this.els.swiperNav.appendChild(this.els.swiperNext);
      
      this.els.swiper.appendChild(this.els.swiperWrapper);
      this.els.swiper.appendChild(this.els.swiperNav);
      
      this.els.modal.appendChild(this.els.closeModal);
      this.els.modal.appendChild(this.els.swiper);

      document.body.appendChild(this.els.modal);
    }
    
    cloneImages() {

      this.imgs.forEach((img,i) => {
        
        let slide_num = i + 1;
        let imgClone = img.cloneNode();
        let slide = this.createElement('div', false, 'swiper-slide');

        slide.appendChild(imgClone);
        slide.setAttribute('data-slide',slide_num);
        this.els.swiperWrapper.appendChild(slide);
    
        img.setAttribute('data-href','#'+this.galleryId);
        img.setAttribute('data-slide',slide_num);
        img.addEventListener('click',function(){
          let slideNum = this.dataset.slide;
          if(slide_num) this.swiperObj.slideTo(slideNum,0);
        });
    
      });

    }
      
    initSwiper() {
      
      this.swiper = new Swiper('#'+this.popupId+' .swiper', {
          module: [Navigation, Pagination],
          speed:1000,
          delay:5000,
          effect: 'opacity',
          slidesPerView: 1,
          loop:true,
          autoplay:false,
          centeredSlides : false,
          spaceBetween:0,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
      });

    }

    createElement(tag, el_id = false, el_class = false) {
      let el = document.createElement(tag);
      if(el_id) el.id = el_id;
      if(el_class) el.classList.add(el_class);
      return el;
    }
  
}